import React, { useState } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { copyTextToClipboard } from '../../utils/utils';

type CopyButtonProps = {
    value: string | null | undefined;
    label?: string;
} & Omit<ButtonProps, 'value'>;

const CopyButton = ({
    value,
    label = 'کپی',
    onClick,
    ...buttonProps
}: CopyButtonProps) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);

        const succeeded = await copyTextToClipboard(value);

        if (succeeded) {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    return (
        <Button
            size="small"
            color="primary"
            {...buttonProps}
            sx={[
                (theme) => ({
                    minWidth: 0,
                    borderRadius: 1.5,
                    color:
                        theme.palette.mode === 'dark'
                            ? theme.palette.primary.light
                            : theme.palette.primary.main,
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? alpha(theme.palette.primary.main, 0.12)
                            : alpha(theme.palette.primary.main, 0.055),
                    border: '1px solid',
                    borderColor:
                        theme.palette.mode === 'dark'
                            ? alpha(theme.palette.primary.light, 0.18)
                            : alpha(theme.palette.primary.main, 0.1),
                    '&:hover': {
                        color:
                            theme.palette.mode === 'dark'
                                ? theme.palette.primary.light
                                : theme.palette.primary.dark,
                        backgroundColor:
                            theme.palette.mode === 'dark'
                                ? alpha(theme.palette.primary.main, 0.2)
                                : alpha(theme.palette.primary.main, 0.1),
                        borderColor: alpha(theme.palette.primary.main, 0.28),
                    },
                    '& .MuiButton-startIcon': {
                        marginInlineEnd: 0.75,
                        marginInlineStart: 0,
                    },
                }),
                ...(Array.isArray(buttonProps.sx)
                    ? buttonProps.sx
                    : buttonProps.sx
                      ? [buttonProps.sx]
                      : []),
            ]}
            startIcon={
                <i
                    className={
                        isCopied
                            ? 'fa-light fa-check'
                            : 'fa-light fa-copy'
                    }
                />
            }
            onClick={handleCopy}
        >
            {isCopied ? 'کپی شد' : label}
        </Button>
    );
};

export { CopyButton };
